import Vue from 'vue'
// import store from '@/store'
import router from '@/router'
import VueResource from 'vue-resource'
import { VueAuthenticate } from 'vue-authenticate'
import appConfig from '@/config.js'
Vue.use(VueResource)

const vueAuthInstance = new VueAuthenticate(Vue.http, {
  baseUrl: appConfig.api.baseUrl,
  loginUrl: '/login',
  registerUrl: '/users',
  logoutUrl: '/logout',
  refreshUrl: '/login/refresh',
  requestDataKey: 'body',
  storageNamespace: 'moova.io',
  tokenPrefix: 'auth',
  refreshType: 'storage',
  refreshTokenPrefix: 'auth',
  expirationPrefix: 'auth',
  bindRequestInterceptor: function ($auth) {
    let interceptor = function (request, next) {
      if ($auth.isAuthenticated() && request.url.includes(appConfig.api.baseUrl)) {
        request.headers.set('Authorization', [
          $auth.options.tokenType, $auth.getToken()
        ].join(' '))
      } else {
        request.headers.delete('Authorization')
      }
      next(async function (response) {
        if (request.url.includes(appConfig.api.baseUrl)) {
          if (response.status === 401 && request.url.indexOf('meli') === -1 && $auth.options.refreshType && $auth.isTokenSet()) {
            // check if we are already refreshing, to prevent endless loop
            if (!$auth._isRefreshing) {
              $auth._isRefreshing = true
              // Try to refresh our token
              return await $auth.refresh()
                .then(function (response) {
                  // refreshing was successful :)
                  $auth._isRefreshing = false
                  // full reload the page
                  window.location.reload()
                })
                .catch(function (error) {
                  console.log(error)
                  // Refreshing fails :(
                  $auth._isRefreshing = false
                  // store.dispatch('logout')
                  router.push({ name: 'login' })
                })
            }
          }
        }
        return response
      })
    }

    this.$http.interceptors.push(interceptor)
  },

  providers: {
    facebook: {
      clientId: appConfig.auth.facebook.clientId,
      url: appConfig.api.baseUrl + 'oauth/social/facebook?country_iso_code=' + document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === 'country' ? decodeURIComponent(parts[1]) : r
      }, ''),
      redirectUri: window.location.origin + '/oauth',
      responseType: 'token',
      defaultUrlParams: ['response_type', 'client_id', 'redirect_uri', 'access_token'],
      responseParams: {
        'accessToken': 'access_token'
      }
    },
    google: {
      clientId: appConfig.auth.google.clientId,
      url: appConfig.api.baseUrl + 'oauth/social/google?country_iso_code=' + document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === 'country' ? decodeURIComponent(parts[1]) : r
      }, ''),
      redirectUri: window.location.origin + '/oauth',
      responseType: 'token',
      defaultUrlParams: ['response_type', 'client_id', 'redirect_uri', 'access_token'],
      responseParams: {
        'accessToken': 'access_token'
      }
    }
  }
})

export default vueAuthInstance
